import React from 'react';
import Switch from '@mui/material/Switch';
import { CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';

import {
  IgnorableNotificationMessageIds,
  NotificationChannelType,
  NotificationSettingsPageQuery,
  useSetOrganizationNotificationMessageSettingMutation,
} from 'generated/graphql';
import { showErrorAction } from 'containers/Notification/actions';

type Message = NonNullable<
  NonNullable<
    NonNullable<NotificationSettingsPageQuery['notificationMetadata']>['messages']
  >[number]
>;

export const MessageSwitch = ({
  message,
  data,
}: {
  message: Message;
  data: NotificationSettingsPageQuery;
}) => {
  const dispatch = useDispatch();
  const categoryIsMuted = data.organizationNotificationSettings?.email?.mutedCategories.includes(
    message.category
  );
  const messageIsMuted =
    !message.unignorable &&
    (categoryIsMuted ||
      data.organizationNotificationSettings?.email?.mutedMessages.includes(message.id));
  const [setOrganizationNotificationMessageSetting, { loading }] =
    useSetOrganizationNotificationMessageSettingMutation({
      onError: () => {
        dispatch(showErrorAction('An error occurred, please try again.'));
      },
    });
  if (loading) {
    return <CircularProgress style={{ marginLeft: 8, width: 33, height: 33 }} />;
  }
  return (
    <Switch
      disabled={Boolean(message.unignorable)}
      checked={!messageIsMuted}
      onChange={(event) => {
        void setOrganizationNotificationMessageSetting({
          variables: {
            channel: NotificationChannelType.Email,
            messageId: message.id as IgnorableNotificationMessageIds,
            muted: !event.target.checked,
          },
        });
      }}
    />
  );
};
